export default __webpack_public_path__ + "static/media/logo-lg.38d1afc4.svg";